import { useCallback } from 'react';
import { useTrackedPageContext } from 'src/context/trackedPage';
import {
  AnalyticsDataAction,
  AnalyticsDataClickArea,
  AnalyticsDataEvent,
  AnalyticsDataProperty,
  AnalyticsEventClickCta,
} from 'src/types/googleAnalyticsEvents';

export function useEventGeneratorClickCta(properties?: {
  action?: AnalyticsDataAction;
  clickArea?: AnalyticsDataClickArea;
}): (e: MouseEvent) => AnalyticsEventClickCta {
  const trackedPageContext = useTrackedPageContext();

  return useCallback(
    e => ({
      [AnalyticsDataProperty.event]: AnalyticsDataEvent.clickCta,
      [AnalyticsDataProperty.action]: properties?.action || AnalyticsDataAction.signUp,
      [AnalyticsDataProperty.clickArea]: properties?.clickArea || AnalyticsDataClickArea.content,
      [AnalyticsDataProperty.clickPath]: (e.currentTarget as HTMLElement)?.innerText,
      ...trackedPageContext,
    }),
    [properties, trackedPageContext],
  );
}
